import { render } from "./DocDurationList.vue?vue&type=template&id=4f3b79cd"
import script from "./DocDurationList.vue?vue&type=script&lang=js"
export * from "./DocDurationList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__